import { Box, Grid, Typography, makeStyles } from '@material-ui/core';
import { InfoCard, Link } from '@backstage/core-components';
import CreateComponentIcon from '@material-ui/icons/AddCircleOutline';
import CategoryIcon from '@material-ui/icons/Category';
import SchoolIcon from '@material-ui/icons/School';

const useStyles = makeStyles(theme => ({
  actionCard: {
    padding: theme.spacing(3),
    textAlign: 'center',
    cursor: 'pointer',
    transition: 'transform 0.2s',
    '&:hover': {
      transform: 'translateY(-4px)',
    },
  },
  actionIcon: {
    fontSize: '3rem',
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1),
  },
  actionLabel: {
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
  actionDescription: {
    marginTop: theme.spacing(1),
    fontSize: '0.875rem',
    color: theme.palette.text.secondary,
  },
  cardTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
}));

const quickActions = [
  {
    url: '/accelerators',
    label: 'Create',
    description:
      'Use our templates to quickly scaffold new services and components.',
    icon: CreateComponentIcon,
  },
  {
    url: '/catalog',
    label: 'Catalog',
    description:
      'Browse our software catalog to find components, services, and documentation.',
    icon: CategoryIcon,
  },
  {
    url: '/learn',
    label: 'Learn & Grow',
    description:
      'Access technical documentation and guides for all your projects.',
    icon: SchoolIcon,
  },
];

export const QuickActionsCard = () => {
  const classes = useStyles();

  return (
    <InfoCard title={<Box className={classes.cardTitle}>Quick Actions</Box>}>
      <Grid container spacing={3}>
        {quickActions.map(action => {
          const IconComponent = action.icon;
          return (
            <Grid item xs={12} sm={6} md={4} key={action.label}>
              <Link to={action.url} style={{ textDecoration: 'none' }}>
                <Box className={classes.actionCard}>
                  <IconComponent className={classes.actionIcon} />
                  <Typography className={classes.actionLabel}>
                    {action.label}
                  </Typography>
                  <Typography className={classes.actionDescription}>
                    {action.description}
                  </Typography>
                </Box>
              </Link>
            </Grid>
          );
        })}
      </Grid>
    </InfoCard>
  );
};
